var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompleted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "checkbox-circle-fill"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.50004 14.6666C4.81814 14.6666 1.83337 11.6818 1.83337 7.99992C1.83337 4.31802 4.81814 1.33325 8.50004 1.33325C12.1819 1.33325 15.1667 4.31802 15.1667 7.99992C15.1667 11.6818 12.1819 14.6666 8.50004 14.6666ZM7.83511 10.6666L12.5492 5.95254L11.6064 5.00973L7.83511 8.78098L5.94951 6.89532L5.0067 7.83818L7.83511 10.6666Z",
    fill: "#165E3D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleted);
export default __webpack_public_path__ + "static/media/completed.08db0bee25084b62f86abbf1802181dd.svg";
export { ForwardRef as ReactComponent };